import { createGlobalStyle } from 'styled-components'
import { media } from '../mediaQuery'

import SidecartaSansRegular from './assets/fonts/sidecarta-sans/SidecartaSans-Regular.woff2'
import SidecartaSansBold from './assets/fonts/sidecarta-sans/SidecartaSans-Bold.woff2'
import SidecartaSansSemiBold from './assets/fonts/sidecarta-sans/SidecartaSans-SemiBold.woff2'

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  
  #root {
    width: 100%;
    height: 100%;
  }
  
  *:focus,
  *:active {
    outline: none;
  }
  
  /* Overwrite Chrome autofill yellow fields */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  }
  
  /**
   * Typographic Styling
   *
   * This is done here to save us from having to create
   * styled components or a theme to just use a regular
   * <h1> or <a> tag
   */
  
  /* subtitles get pushed closer to the title */  
  p.disclaimer {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #666;
    margin: 0 0 0.625rem;
  }
  
  p:last-child {
    margin-bottom: 0;
  }
  
  a {
    color: #64c5af;
    text-decoration: none;
    cursor: pointer;
  }
  
  a:hover {
    color: #2c949a;
  }
  
  a:active {
    color: #2c949a;
  }
  
  ul,
  ol {
    padding-left: 1.875rem;
  }
  
  /* removes pesky rounded corners and styles in iOS */
  input {
    border-radius: 0;
    -webkit-appearance: none;
    appearance: none;
  }
  
  /* removes the 'spinner' (up/down) buttons on number fields */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: none;
    display: none;
  }
  
  img {
    flex-shrink: 0;
  }
  
  /* https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone */
  @media (max-width: 480px) {
    input[type='text'],
    input[type='number'],
    input[type='email'],
    input[type='password'],
    input[type='search'],
    input[type='date'] {
      font-size: 16px;
    }
  }
  
  sup {
    position: relative;
    vertical-align: baseline;
    top: -0.5em;
    line-height: 0;
  }

  @media print
  body .acsb-trigger.acsb-ready, .designstudio-button {
    display: none !important;
  }
`

export const GlobalStylesV2 = createGlobalStyle`
  @font-face {
    font-family: 'sidecarta-sans';
    src: url('${SidecartaSansRegular}') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'sidecarta-sans-bold';
    src: url('${SidecartaSansBold}') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'sidecarta-sans-semibold';
    src: url('${SidecartaSansSemiBold}') format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }

  #root {
    height: 100%;
    width: 100%;
  }

  *:focus,
  *:active {
    outline: none;
  }

  /* Overwrite Chrome autofill yellow fields */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  }

  @media print
  body .acsb-trigger.acsb-ready, .designstudio-button {
    display: none !important;
  }

  h1,
  .h1 {
    font-family: 'sidecarta-sans-semibold', sans-serif;
    font-weight: 600;
    line-height: 4.5rem;
    font-size: 4rem;
    color: #191654;
    margin: 0 0 1.5rem;
    font-variant-numeric:lining-nums;
  }
  h2,
  .h2 {
    font-family: 'sidecarta-sans-semibold', sans-serif;
    font-weight: 600;
    line-height: 3.5rem;
    font-size: 3rem;
    color: #24272e;
    margin: 2.5rem 0 1.5rem;
    font-variant-numeric:lining-nums;
  }
  h3,
  .h3 {
    font-family: 'sidecarta-sans-semibold', sans-serif;
    font-weight: 600;
    line-height: 3rem;
    font-size: 2rem;
    color: #24272e;
    margin: 2.5rem 0 1.5rem;
    font-variant-numeric:lining-nums;
  }
  h4,
  .h4 {
    font-family: 'sidecarta-sans-semibold', sans-serif;
    font-weight: 600;
    line-height: 2rem;
    font-size: 1.5rem;
    color: #24272e;
    margin: 1.5rem 0 0.5rem;
    font-variant-numeric:lining-nums;
  }
  h5,
  .h5 {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 700;
    line-height: 2rem;
    font-size: 1.125rem;
    color: #24272e;
    margin: 1.5rem 0 0.5rem;
  }

  // multi-line paragraph elements
  p,
  .p {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 400;
    line-height: 2rem;
    font-size: 1.125rem;
    margin: 0 0 1.0625rem;
    color: #474747;

    &:last-child {
      margin-bottom: 0;
    }
  }

  // used when a paragraph is just one line
  p.default {
    line-height: 1.5rem;
  }

  // special margins
  h1 + h2,
  h1 + p,
  h2 + p {
    margin-top: -1.25;
  }

  p + h1 {
    margin-top: -1.25
  }

  // multi-line small elements
  small,
  .small {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 400;
    line-height: 1.5rem;
    font-size: 0.875rem;
    margin: 0 0 0.5rem;
    color: #757575;
  }

  // used when a small is just one line
  small.default {
    line-height: 1.0625rem;
  }

  .medium-currency {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 700;
    line-height: 2.5rem;
    font-size: 1.75rem;
    color: #24272e;
    margin: 0;
    font-variant-numeric:lining-nums;
  }

  .large-currency {
    font-family: 'sidecarta-sans-semibold', sans-serif;
    font-weight: 600;
    line-height: 3rem;
    font-size: 2.5rem;
    color: #24272e;
    font-variant-numeric:lining-nums;

    sup {
      font-size: 1.125rem;
      vertical-align: super;
      top: 0;
    }
  }

  p.caption, small.caption {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 400;
    line-height: 1.0625rem;
    font-size: 0.75rem;
    color: #757575;
    margin: 0 0 0.5rem;
    text-transform: uppercase;
    font-variant-numeric:lining-nums;
  }

  strong,
  .strong {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 700;
    line-height: 1.5rem;
    font-size: 1.125rem;
    color: #24272e;
    font-variant-numeric:lining-nums;
  }

  ul,
  ol {
    font-family: 'sidecarta-sans', sans-serif;
    font-weight: 400;
    line-height: 2rem;
    font-size: 1.125rem;
    padding: 0 0 0 2rem;
    margin: 0 0 1.0625rem;
    color: #757575;
  }

  li {
    margin-bottom:  0.5rem;
  }

  ul.small,
  ol.small {
    font-size: 0.875rem;
    line-height 1.5rem;
    padding: 0 0 0 1.5rem;
  }

  ul.small li,
  ol.small li {
    margin-bottom: 0.25rem;
  }

  pre, .p pre {
    margin: 0;
    color: #474747;
    display: inline;
  }

  a, 
  p a, 
  .p a, 
  small a, 
  .small a, 
  strong a, 
  .strong a {
    color: #00888f;
    text-decoration: none;

    &:hover, &:focus {
      color: #00656A;
      cursor: pointer;
    }
    &:active {
      text-decoration: underline;
    }
    &:visited {
      color: #00656A;
    }
  }

  blockquote {
    margin: 0;
    h4 {
      color: #191654;
      margin: 0 0 1.0625rem;
    }

    small {
      text-transform: uppercase; 
      font-size: 0.75rem;
    }
  }
  
  /* removes pesky rounded corners and styles in iOS */
  input {
    border-radius: 0;
    -webkit-appearance: none;
    appearance: none;
  }
  
  /* removes the 'spinner' (up/down) buttons on number fields */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: none;
    display: none;
  }
  
  img {
    flex-shrink: 0;
  }
  
  /* https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone */
  @media (max-width: 480px) {
    input[type='text'],
    input[type='number'],
    input[type='email'],
    input[type='password'],
    input[type='date'] {
      font-size: 16px;
    }
  }
  
  sup {
    position: relative;
    vertical-align: baseline;
    top: -0.5em;
    line-height: 0;
  }

  ${media.mobileAndBelow`
    h1, .h1 {
      line-height: 3rem;
      font-size: 2.25rem;
    }
    h2, .h2 {
      line-height: 2.5rem;
      font-size: 1.75rem;
    }
    h3, .h3 {
      line-height: 2rem;
      font-size: 1.5rem;
      margin: 1.5rem 0 1.0625rem;
    }
    h4, .h4 {
      font-size: 1.25rem;
    }
    h5, .h5 {
      line-height: 1.75rem;
    }
    p, .p {
      line-height: 1.75rem;
    }
    small, .small {
      line-height: 1.25rem;
    }
  `}
`
